import Vue from 'vue'
import Router from 'vue-router'
import HomeView from './views/HomeView.vue'
import AccountView from './views/AccountView.vue'
import NewAccountView from './views/NewAccountView.vue'
import EditAccountView from './views/EditAccountView.vue'
import CustomerView from '@/views/CustomerView.vue'
import NewCustomerView from '@/views/NewCustomerView.vue'
import EditCustomerView from '@/views/EditCustomerView.vue'
import ModuleView from '@/views/ModuleView.vue'
import NewModuleView from '@/views/NewModuleView.vue'
import EditModuleView from '@/views/EditModuleView.vue'
import StocktakingView from '@/views/StocktakingView.vue'
import NewStocktakingView from '@/views/NewStocktakingView.vue'
import EditStocktakingView from '@/views/EditStocktakingView.vue'
import StocktakingStatisticView from './views/StocktakingStatisticView'
import StocktakingCloseView from './views/StocktakingCloseView'
import StocktakingAdminView from "@/views/StocktakingAdminView.vue";
import MyProfileView from '@/views/MyProfileView'
import AboutView from './views/AboutView.vue'
import Login from './views/Login.vue'
import EditLocationView from './views/EditLocationView'
import { requireAuth } from './utils/auth.js'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homeView',
      beforeEnter: requireAuth,
      component: HomeView
    },
    {
      path: '/accounts',
      name: 'accountView',
      beforeEnter: requireAuth,
      component: AccountView
    },
    {
      path: '/accounts/new',
      name: 'newAccountView',
      beforeEnter: requireAuth,
      component: NewAccountView
    },
    {
      path: '/accounts/edit',
      name: 'editAccountView',
      beforeEnter: requireAuth,
      component: EditAccountView
    },
    {
      path: '/customers',
      name: 'customerView',
      beforeEnter: requireAuth,
      component: CustomerView
    },
    {
      path: '/customers/new',
      name: 'newCustomerView',
      beforeEnter: requireAuth,
      component: NewCustomerView
    },
    {
      path: '/customers/edit',
      name: 'editCustomerView',
      beforeEnter: requireAuth,
      component: EditCustomerView
    },
    {
      path: '/stocktakings',
      name: 'stocktakingView',
      beforeEnter: requireAuth,
      component: StocktakingView
    },
    {
      path: '/stocktakings/admin',
      name: 'stocktakingAdminView',
      beforeEnter: requireAuth,
      component: StocktakingAdminView
    },
    {
      path: '/stocktakings/new',
      name: 'newStocktakingView',
      beforeEnter: requireAuth,
      component: NewStocktakingView
    },
    {
        path: '/stocktakings/edit',
        name: 'editStocktakingView',
        beforeEnter: requireAuth,
        component: EditStocktakingView
    },
    {
      path: '/stocktakings/statistic',
      name: 'stocktakingStatisticView',
      beforeEnter: requireAuth,
      component: StocktakingStatisticView
    },
    {
      path: '/stocktakings/close',
      name: 'stocktakingCloseView',
      beforeEnter: requireAuth,
      component: StocktakingCloseView
    },
    {
      path: '/locations/edit',
      name: 'locationEditView',
      beforeEnter: requireAuth,
      component: EditLocationView
    },
    {
      path: '/modules',
      name: 'modulesView',
      beforeEnter: requireAuth,
      component: ModuleView
    },
    {
      path: '/modules/new',
      name: 'newModuleView',
      beforeEnter: requireAuth,
      component: NewModuleView
    },
    {
      path: '/modules/edit',
      name: 'editModuleView',
      beforeEnter: requireAuth,
      component: EditModuleView
    },
    {
      path: '/myprofile',
      name: 'myProfileView',
      beforeEnter: requireAuth,
      component: MyProfileView
    },
    {
      path: '/about',
      name: 'about',
      beforeEnter: requireAuth,
      component: AboutView
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})
